import { render, staticRenderFns } from "./AnimBottomToTop.vue?vue&type=template&id=25601476&scoped=true"
import script from "./AnimBottomToTop.vue?vue&type=script&lang=js"
export * from "./AnimBottomToTop.vue?vue&type=script&lang=js"
import style0 from "./AnimBottomToTop.vue?vue&type=style&index=0&id=25601476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25601476",
  null
  
)

export default component.exports